<script setup>
import ModalBox from './ModalBox.vue'
import FormButton from '@/components/Atoms/FormButton.vue'
import { bytes } from '@/filtersNew'
import { useLegacyModalBridge } from '@/composables/useLegacyModalBridge'

const props = defineProps({
	modalId: {
		type: String,
		default: 'modal-alert',
	},
	message: {
		type: String,
		required: false,
	},
	file: {
		required: false,
	},
	body: {
		type: String,
		required: true,
	},
	okText: {
		type: String,
		default: 'Yes',
	},
	buttonAlignment: {
		type: String,
		default: '',
	},
})

const emit = defineEmits(['modal-confirm'])

const { isVisible, hide } = useLegacyModalBridge(() => props.modalId)

const onConfirm = () => {
	emit('modal-confirm')
	hide()
}

const bytesFormated = (item) => bytes(item)
</script>

<template>
	<ModalBox
		v-model="isVisible"
		size="sm"
		hide-close
		header-class="!hidden"
		wrapper-classes="lg:h-auto lg:max-h-none"
	>
		<div v-if="message" class="px-6 pt-6 text-surface-text-2">
			{{ message }}
		</div>
		<div class="px-6 pt-4 text-surface-7 text-sm" :class="{ 'pt-6': !message }">
			{{ body }}
		</div>
		<div v-if="file" class="mx-6 mt-4 flex justify-between text-surface-7 text-sm">
			<span>{{ file.name }}</span>
			<span class="text-danger uppercase">{{ bytesFormated(file.size) }}</span>
		</div>
		<template #footer>
			<div :class="[buttonAlignment, 'flex justify-end gap-2 p-6']">
				<FormButton type="secondary" size="md" @click="onConfirm">
					{{ okText }}
				</FormButton>
				<FormButton type="main" size="md" target="_blank" href="/app/subscribe">
					Upgrade
				</FormButton>
			</div>
		</template>
	</ModalBox>
</template>
